<template>
  <div class="container py-5">
    <h2 class="mb-4 text-center">Pet Smart Temperature Device</h2>
    <div class="text-center">
      <img src="/img/therapeutic/pet-temp-device.jpeg"
           alt="Pet Smart Temperature Device"
           style="max-width:90%;height:auto;border-radius:10px;box-shadow:0 4px 18px rgba(0,0,0,.1);" />
    </div>
    <p class="mt-4 text-center">
      Our Pet Smart Temperature Device helps you monitor and manage your pet’s health with accurate
      temperature readings and smart connectivity features.
    </p>
  </div>
</template>

<script>
export default {
  name: "PetSmartTemperatureDevice"
}
</script>

<style scoped>
/* 필요하면 스타일 추가 */
</style>